import React from "react";

import NewReceipt from "../../../presentation/pages/Receipts/New";
import { makeDbLoadProductListByManyCodes } from "../usecases/load-product-list-by-many-codes-factory";
import { makeDbLoadProductList } from "../usecases/load-product-list-factory";
import { makeReadReceiptNF } from "../usecases/read-receipt-nf-factory";
import { makeDbSaveReceipt } from "../usecases/save-receipt-factory";

export const makeReceipts = () => {
  return (
    <NewReceipt
      readReceiptNF={makeReadReceiptNF()}
      saveReceipt={makeDbSaveReceipt()}
      loadProductList={makeDbLoadProductListByManyCodes()}
    />
  );
};
